import Model from "./base/model";

class SimulationQuotes extends Model {
  resourceName() {
    return "simulation_quotes";
  }

  fields() {
    return {
      company_id: "",
      simulation: "",
      return_simulation: "",
      response: "",
      created_at: "",
      company: "",
      vehicle_type: "",
      road_map: "",
      simulation_quotes_transporters: "",
      simulation_quotes_files: "",
      observation: "",
      weight: "",
      bulk: "",
      cubage: "",
      invoice_value: "",
      description_material: "",
      packaging_type: "",
      collection_date_time: "",
      delivery_date_time: "",
      services: "",
      items: "",
      modals: "",
      dangerous_products: "",
      weight_air: "",
      cubage_air: "",
      road_map_id: "",
      has_freight_approved_value: "",
      vehicle_type_id: "",
      delivery: "",
      collect: "",
      files: "",
      invoices: "",
      shipper: "",
      transporter: "",
      addresses: "",
      erp_request_type: "",
      response_time_limit: "",
      erp_product_type: "",
      user_id: "",
      user: "",
      vehicle_options: "",
      transporters: "",
      cost_center: "",
      route_km: "",
      no_obligation_quote:"",
      quote_name:"",
      correios_modals_transport: "",
      simulate: "",
      simulate_reverse: "",
      jadlog_modalities: "",
      request_ids: "",
      cubage_weight: "",
      accepted_quote_transporter_justification: "",
      awaiting_approver_user: "",
      is_traceable: "",
      freight_type: "",
      products: {jsonApi: 'hasMany', type:'request'},
    };
  }

  async get(filters) {

    return this.request(
      this.resourceName(),
      "GET",
      filters
    );


  }
  async getId(id, filters) {

    return this.request(
      this.resourceName() + `/${id}`,
      "GET",
      filters
    );

  }

  async getTransporterSimulationQuotes(filters) {

    return this.request(
      this.resourceName(),
      "GET",
      filters
    );

  }

  async getTransporterSimulationQuotesDetails(id, filters) {

    return this.request(
      this.resourceName() + `/${id}`,
      "GET",
      filters
    );

  }

}

export default new SimulationQuotes();
